import { emptyAdminApi as api } from "../../emptyAdminApi";
import {DealRedeemItem} from "./DealRedeemItem";

export const addTagTypes = ["DealRedeems"] as const;
const SLUG = "/webshop/promo"
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAllDealRedemptions: build.query<DealRedeemItem[], void>({
        query: () => ({
          url: SLUG + "/manage?action=redeemption",
          method: "GET",
        }),
        providesTags: ["DealRedeems"],
      }),
      getPromoRedeemptions: build.query<DealRedeemItem[], string>({
        query: (id) => ({
          url: SLUG + "/manage?action=redeemption&code=" + id,
          method: "GET",
        }),
        providesTags: ["DealRedeems"],
      }),
      //  getDealRedeemsForUser: build.query<string, DealRedeemItem>({
      //   query: (userId) => ({
      //     url: SLUG + "/manage?id=" + userId,
      //     method: "GET",
      //   }),
      //   providesTags: ["DealRedeems"],
      // }),
      //   getDealRedeemsForPromo: build.query<string, DealRedeemItem>({
      //   query: (promoCode) => ({
      //     url: SLUG + "/manage?id=" + promoCode,
      //     method: "GET",
      //   }),
      //   providesTags: ["DealRedeems"],
      // }),
      // getDealRedeemsForBundle: build.query<string, DealRedeemItem>({
      //   query: (bundleId) => ({
      //     url: SLUG + "/manage?id=" + bundleId,
      //     method: "GET",
      //   }),
      //   providesTags: ["DealRedeems"],
      // }),
      
    //   getBundleDealsUploadJobs: build.query<PlanUploadJobItem[], void>({
    //     query: () => SLUG + "/upload",
    //     providesTags: ["BundleDeals"],      
    //   }),
    

    }),
  });

export const {
  useGetAllDealRedemptionsQuery,
  useGetPromoRedeemptionsQuery,

} = injectedRtkApi;
